import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../ts/ServerApi/types/IGetItemsResult';
import { IMaxDownstreamDatasources, IMaxDownstreamWorkbooks } from '../../../../ts/ServerApi/types/IMaxDownstreamConnections';
import { ITable } from '../../types/ITable';

export interface IGetTablesParams extends IGetItemsParams {
}

export interface IGetTablesResult extends IGetItemsResult {
  tables?: ITable[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetTablesRequest extends Request<IGetTablesParams, IGetTablesResult> {
  constructor(params: IGetTablesParams) {
    super('getTables', params);
  }
}